import { z } from "zod";

export const errorCodeSchema = z.enum([
  "PROTOCOL_MISMATCH",
  "UNAUTHORIZED",
  "RATE_LIMITED",
  "ALREADY_SUBMITTED",
  "ALREADY_RELEASED",
  "SUBMISSION_NOT_FOUND",
  "SESSION_REQUIRED",
  "PARTICLE_CAP_REACHED",
  /** The round is in `pattern` or `completed`: an admin reset is needed before new particles. */
  "ROUND_CLOSED",
  "VALIDATION_FAILED",
  "INTERNAL",
]);
export type ErrorCode = z.infer<typeof errorCodeSchema>;

export const errorBodySchema = z.object({
  error: z.object({
    code: errorCodeSchema,
    message: z.string(),
  }),
});
export type ErrorBody = z.infer<typeof errorBodySchema>;

/** HTTP status each error code maps to, so routes and clients agree. */
export const ERROR_STATUS: Record<ErrorCode, number> = {
  PROTOCOL_MISMATCH: 400,
  UNAUTHORIZED: 401,
  RATE_LIMITED: 429,
  ALREADY_SUBMITTED: 409,
  ALREADY_RELEASED: 409,
  SUBMISSION_NOT_FOUND: 404,
  SESSION_REQUIRED: 401,
  PARTICLE_CAP_REACHED: 409,
  ROUND_CLOSED: 409,
  VALIDATION_FAILED: 400,
  INTERNAL: 500,
};
